export default {"src":"/_next/static/media/rugby-union.7e6a2eec.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};